// export default ProductMap = {
exports.ProductMap = {
  10: {
    '2kWh': [{
      name: '기본 키트(2kWh)',
      pid: '7516911304873',
      varId: '42308593942697',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5158000',
      old_price: '5158000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '1 * 2kWh 인산철 배터리', '1 * 케이블 팩'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: '기본 키트를 사용하면 인산철 배터리와 파워 허브를 통해 승합차/야외 공간을 위한 기본 전기 시스템을 신속하게 구축할 수 있습니다.'
    }, {
      name: '중급 키트(2kWh)',
      pid: '7516911304873',
      varId: '42308593975465',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5743000',
      old_price: '5743000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '1 * 2kWh 인산철 배터리', '1 * 케이블 팩', '1 * AC/DC 스마트 배전 패널', '1 * 배터리 마운팅 스트랩'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: '중급 키트는 전원 사용량을 보다 효과적으로 제어하여 여행이나 오프그리드에 편리함을 제공합니다.'
    }],
    '4kWh': [{
      name: '기본 키트(4kWh)',
      pid: '7516992405673',
      varId: '42308871782569',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '7454000',
      old_price: '7454000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '2 * 2kWh 인산철 배터리', '1 * 케이블 팩'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: '기본 키트를 사용하면 인산철 배터리와 파워 허브를 통해 승합차/야외 공간을 위한 기본 전기 시스템을 신속하게 구축할 수 있습니다.'
    }, {
      name: '중급 키트(4kWh)',
      pid: '7516992405673',
      varId: '42308871848105',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '8066000',
      old_price: '8066000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '2 * 2kWh 인산철 배터리', '1 * 케이블 팩', '1 * AC/DC 스마트 배전 패널', '2 * 배터리 마운팅 스트랩'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: '중급 키트는 전원 사용량을 보다 효과적으로 제어하여 여행이나 오프그리드에 편리함을 제공합니다.'
    }],
    '5kWh': [{
      name: '기본 키트(5kWh)',
      pid: '7516994109609',
      varId: '42308882530473',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '7800000',
      old_price: '7800000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '1 * 5kWh 인산철 배터리', '1 * 케이블 팩'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: '기본 키트를 사용하면 인산철 배터리와 파워 허브를 통해 승합차/야외 공간을 위한 기본 전기 시스템을 신속하게 구축할 수 있습니다.'
    }, {
      name: '중급 키트(5kWh)',
      pid: '7516994109609',
      varId: '42308882563241',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '8385000',
      old_price: '8385000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '1 * 5kWh 인산철 배터리', '1 * 케이블 팩', '1 * AC / DC 스마트 배전 패널', '1 * 배터리 마운팅 스트랩'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: '중급 키트는 전원 사용량을 보다 효과적으로 제어하여 여행이나 오프그리드에 편리함을 제공합니다.'
    }],
    '10kWh': [{
      name: '기본 키트(10kWh)',
      pid: '7516994896041',
      varId: '42308890788009',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '12642000',
      old_price: '12642000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '2 * 5kWh 인산철 배터리', '1 * 케이블 팩'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: '기본 키트를 사용하면 인산철 배터리와 파워 허브를 통해 승합차/야외 공간을 위한 기본 전기 시스템을 신속하게 구축할 수 있습니다.'
    }, {
      name: '중급 키트(10kWh)',
      pid: '7516994896041',
      varId: '42308890820777',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '13480000',
      old_price: '13480000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '1 * 5kWh 인산철 배터리', '1 * 케이블 팩', '1 * AC/DC 스마트 배전 패널', '1 * 배터리 마운팅 스트랩'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: '중급 키트는 전원 사용량을 보다 효과적으로 제어하여 여행이나 오프그리드에 편리함을 제공합니다.'
    }],
    '15kWh': [{
      name: '기본 키트(15kWh)',
      pid: '7516995682473',
      varId: '42308896096425',
      off_price: '17755000',
      old_price: '17755000',
      consoleChoose: 'Y',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '3 * 5kWh 인산철 배터리', '1 * 케이블 팩'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: '기본 키트를 사용하면 인산철 배터리와 파워 허브를 통해 승합차/야외 공간을 위한 기본 전기 시스템을 신속하게 구축할 수 있습니다.'
    }, {
      name: '중급 키트(15kWh)',
      pid: '7516995682473',
      varId: '42308896129193',
      off_price: '18315000',
      old_price: '18315000',
      consoleChoose: 'Y',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1 * 파워 허브', '2 * 5kWh 인산철 배터리', '1 * 케이블 팩', '1 * AC/DC 스마트 배전 패널', '2 * 배터리 마운팅 스트랩'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: '중급 키트는 전원 사용량을 보다 효과적으로 제어하여 여행이나 오프그리드에 편리함을 제공합니다.'
    }]
  }
};
exports.solarPanelMap = {
  10: [{
    name: '2*100W 고정식 태양광 패널+2*고정식 태양광 마운팅 피트',
    pid: '7516998795433',
    varId: '42308918640809',
    old_price: '251000',
    off_price: '251000',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W 고정식 태양광 패널+4*고정식 태양광 마운팅 피트',
    pid: '7516998795433',
    varId: '42308918673577',
    old_price: '847000',
    off_price: '847000',
    // save_money: '0',
    // tips: "*This item excludes free shipping.",
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*100W 플렉시블 태양광 패널',
    pid: '7516999745705',
    varId: '42308923424937',
    old_price: '295000',
    off_price: '295000',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }, {
    name: '1*400W 휴대용 태양광 패널',
    pid: '7517000663209',
    varId: '41998639202473',
    old_price: '1390000',
    off_price: '1250000',
    save_money: '140000',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-400w.jpg'
  }]
};
exports.BatteryMap = {
  10: [{
    name: '2kWh 인산철 배터리',
    pid: '7516996960425',
    varId: '42308902191273',
    off_price: '2558000',
    old_price: '2558000',
    // save_money: '0',
    capacity: 2,
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh 인산철 배터리',
    pid: '7516997583017',
    varId: '42423826514089',
    off_price: '5200000',
    old_price: '5200000',
    // save_money: '0',
    capacity: 5,
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }]
};
exports.InstallationMap = {
  10: {
    pid: '7517009019049',
    varId: '42308972871849',
    off_price: '0',
    old_price: '0'
    // save_money: '0'
  }
};

exports.ConsoleMap = {
  10: [{
    name: '에코플로우 파워 키트 콘솔',
    pid: '7549491904681',
    varId: '42423933075625',
    off_price: '355000',
    old_price: '355000',
    limit: 1,
    // save_money: '0',
    // beDepNodeName: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://kr.ecoflow.com/';